import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { parseCurrentBillingAccess, type CurrentBillingAccess } from "@/lib/paywall-access";

export function useCurrentBillingAccess(orgId: string | null, enabled: boolean) {
  const [result, setResult] = useState<{ orgId: string; access: CurrentBillingAccess | null } | null>(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!orgId || !enabled) return;
    let cancelled = false;
    Promise.resolve(supabase.rpc("current_billing_access")).then(({ data, error }) => {
      if (cancelled) return;
      if (error) console.error("[useCurrentBillingAccess]", error.message);
      setResult({ orgId, access: error ? null : parseCurrentBillingAccess(data) });
    });
    return () => { cancelled = true; };
  }, [orgId, enabled, version]);

  const refresh = useCallback(() => setVersion((v) => v + 1), []);
  const loaded = !!orgId && result?.orgId === orgId;

  return {
    access: loaded ? result.access : null,
    loading: enabled && !!orgId && !loaded,
    refresh,
  };
}
